import { Injectable } from '@angular/core';

interface FullscreenDocument extends Document {
  webkitFullscreenElement?: Element;
  webkitExitFullscreen?: () => Promise<void>;
}

interface FullscreenElement extends HTMLElement {
  webkitRequestFullscreen?: () => Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class FullScreenService {

  isFullscreen(): boolean {
    const doc = document as FullscreenDocument;
    return !!(doc.fullscreenElement || doc.webkitFullscreenElement);
  }

  enter(element: HTMLElement = document.documentElement): Promise<void> {
    const el = element as FullscreenElement;
    const request = el.requestFullscreen || el.webkitRequestFullscreen;

    if (request) {
      return request.call(el);
    }
    return Promise.reject(new Error('Fullscreen API not supported'));
  }

  exit(): Promise<void> {
    const doc = document as FullscreenDocument;
    const exit = doc.exitFullscreen || doc.webkitExitFullscreen;

    if (exit) {
      return exit.call(doc);
    }
    return Promise.reject(new Error('Fullscreen API not supported'));
  }

  toggle(element?: HTMLElement): Promise<void> {
    return this.isFullscreen() ? this.exit() : this.enter(element);
  }
}
